module.exports = __webpack_public_path__ + "static/media/logo_1.25b20c80.svg";